const aiGeneratorSwedish = {
  header: {
    title: "AI Inlägg Generator",
    description: "Låt AI hjälpa dig att skapa engagerande LinkedIn-inlägg baserat på dina preferenser"
  },
  customerBanner: {
    working: "Du genererar nu inlägg för"
  },
  loading: {
    posts: "Laddar dina senaste AI-genererade inlägg..."
  },
  noPosts: {
    title: "Inga inlägg hittades",
    description: "Ditt system genererar automatiskt nya LinkedIn-inlägg åt dig varje vecka. När AI genererar dina inlägg kommer de att visas här, där du kan redigera och schemalägga dem.",
    settings: "Om du inte vill vänta kan du gå till",
    settingsLink: "Inställningar",
    settingsAfter: "för att ändra dina preferenser."
  },
  post: {
    author: "LinkedIn Användare",
    time: "Nu •",
    editHint: "Tryck Ctrl+Enter för att spara, Esc för att avbryta"
  },
  stats: {
    likes: "0",
    comments: "0",
    shares: "0"
  },
  aiPrompt: {
    placeholder: "Beskriv hur inlägget ska förbättras...",
    editing: "Redigerar",
    send: "Skicka"
  },
  buttons: {
    retry: "Försök igen",
    generating: "Genererar",
    removeImage: "Ta bort bild",
    nextImage: "Nästa",
    addImage: "Bild",
    accept: "Acceptera",
    scheduling: "Planerar...",
    calculatingTimes: "Beräknar tider...",
    noAvailableTimes: "Inga lediga tider"
  },
  gallery: {
    title: "Välj en bild",
    noImages: "Du har inga bilder i ditt arkiv.",
    goToArchive: "Gå till bildarkiv"
  },
  imageOptions: {
    title: "Lägg till bild",
    gallery: "Välj från bildarkiv",
    upload: "Ladda upp ny bild",
    camera: "Ta foto",
    manage: "Hantera bildarkiv"
  },
  messages: {
    imageUpdated: "Bild uppdaterad!",
    imageRemoved: "Bild borttagen!",
    savedChanges: "Ändringar sparade!",
    regenerated: "Inlägget har regenererats!",
    updated: "Inlägget har uppdaterats!",
    newPost: "Nytt inlägg skapat!",
    accepted: "Ditt inlägg har accepterats och flyttats till \"Mina Inlägg\", där du kan schemalägga det för delning på LinkedIn!",
    calculatingTimes: "Beräknar lediga tider...",
    noScheduledTimes: "Det finns inga schemalagda tider inställda i din schemaläggare. Gå till Schemaläggare för att ställa in tider.",
    postScheduled: "Inlägg schemalagt till {formattedDate}",
    imageUploaded: "Bild uppladdad och tillagd till ditt inlägg!",
    error: "Ett fel uppstod. Försök igen senare."
  }
};

export default aiGeneratorSwedish; 